/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recurringrepeatevery2Inputs */

const en_recurringrepeatevery2 = /** @type {(inputs: Recurringrepeatevery2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repeat every`)
};

const de_recurringrepeatevery2 = /** @type {(inputs: Recurringrepeatevery2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholen alle`)
};

/**
* | output |
* | --- |
* | "Repeat every" |
*
* @param {Recurringrepeatevery2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const recurringrepeatevery2 = /** @type {((inputs?: Recurringrepeatevery2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recurringrepeatevery2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recurringrepeatevery2(inputs)
	return de_recurringrepeatevery2(inputs)
});
export { recurringrepeatevery2 as "recurringRepeatEvery" }